var map = {
	"./bee-welcome-left.svg": "23b0",
	"./bee-welcome-right.svg": "55c1",
	"./bee.svg": "14ed",
	"./christmas-bee.svg": "be31",
	"./halloween-bee.svg": "ea59",
	"./new-year-bee.svg": "dc1f",
	"./trip-bee.svg": "23e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f57";